<template>
  <div class="editor__container">
    <section class="editor__tabs">
      <b-tabs @input="changeTab">
        <b-tab v-for="tab of value" :title="tab.title" :key="tab.title"/>
      </b-tabs>
    </section>
    <section id="editor" class="tabcontent-border">
    </section>
  </div>
</template>
<script>
import CodeMirror from 'codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/neo.css';
import 'codemirror/mode/htmlmixed/htmlmixed';

export default {
  name: 'CodeEditor',
  props: {
    language: String,
    lineNumbers: Boolean,
    theme: {
      type: String,
      default: () => 'neo'
    },
    value: {
      type: Array,
      default: () => [{ title: 'main' }],
    },
  },
  data() {
    return {
      activeTab: 0,
    };
  },
  mounted() {
    this.editor = new CodeMirror(document.getElementById('editor'), {
      mode: this.language,
      theme: this.theme,
      tabSize: 2,
      lineNumbers: this.lineNumbers,
    });
    if (this.value[0].code) {
      this.editor.setValue(this.value[0].code);
    }
    this.editor.on('change', this.updateCode);
  },
  methods: {
    updateCode() {
      this.$emit(
        'input',
        this.value.map((file, tab) => ({
          ...file,
          code: tab === this.activeTab ? this.editor.getValue() : file.code,
        }))
      );
    },
    changeTab(tab) {
      this.activeTab = tab;
      this.editor.setValue(this.value[this.activeTab].code);
    },
  },
};
</script>
<style>
.editor__container {
  width: 100%;
  height: 100%;
  position: relative;
}
.editor__container .editor__tabs .nav-tabs {
  margin-bottom: 0;
}

#editor {
  height: calc(100% - /*tabs height*/ 42px);
  margin: 0 !important;
}
#editor .CodeMirror {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/CodeEditor.vue